class FostrViewSwitcher extends HTMLElement {
  constructor () {
    super()

    // Elements
    this.productGrid = this.closest('fostr-product-grid')
    this.button = this.querySelector('button')

    // Events
    this.button.addEventListener('click', this.onButtonClick.bind(this))
  }

  get isActive () {
    return this.classList.contains('is-active')
  }

  async update () {
    await customElements.whenDefined(this.productGrid.localName)

    if (this.productGrid.view) {
      this.classList.add('is-active')
    } else {
      this.classList.remove('is-active')
    }
  }

  onButtonClick (event) {
    if (this.productGrid) {
      this.productGrid.view = !this.productGrid.view
    } else {
      this.toggleAll()
    }
  }

  async toggleAll () {
    const toggleableElements = document.querySelectorAll(
      'fostr-product-card, fostr-static-product-card',
    )
    const promises = [...toggleableElements].map(el =>
      customElements.whenDefined(el.localName),
    )

    await Promise.all(promises)

    if (!this.isActive) {
      this.classList.add('is-active')
      toggleableElements.forEach(el => (el.alt = true))
    } else {
      this.classList.remove('is-active')
      toggleableElements.forEach(el => (el.alt = false))
    }
  }
}

customElements.define('fostr-view-switcher', FostrViewSwitcher)
